import React, { useState, useEffect } from "react";

// material-ui
import { Box, Button, Checkbox, FormControlLabel, Stack } from "@mui/material";

import AddValuePackCategoryDialog from "./_addValuePackCategoryDialog";
import { getPackageSportCourtType, updatePackageSportCourtType, updatePackageSportCourtTypeGlobal, updatePackageSportCourtTypePlaceGlobal } from "services/packageSportCourtTypeService";
import { TCLabel } from "components/TopCourtComponents/Label/TopCourtLabel";
import TableComponent from "components/TopCourtComponents/Table/TableComponent";
import { updateMerchantSettings } from "services/merchantServices";
import { toast } from "react-toastify";
import { getSportCourtTypes } from "services/sportCourtTypeServices";


export default function ValuePackCategoryComponent({
    merchantId, placeId, globalVP
}) {
    const [isLoading, setLoading] = useState(true)
    const [merchantSportCourtType, setMerchantSportCourtType] = useState([])
    const [rows, setRows] = useState([]);
    const [dialog, setDialog] = useState({
        open: false,
        data: null,
    });
    const [isGlobal, setIsGlobal] = useState(globalVP && placeId != '653f5d9006520fccd4ab4604');
    const [selectedRows, setSelectedRows] = useState(() => new Set());
    const [selectedCategoriesByRow, setSelectedCategoriesByRow] = useState(() => ({}));

    const loadData = async () => {
        try {
            let { data, error } = await getPackageSportCourtType({
                merchantId: !isGlobal ? merchantId : '',
                placeId: !isGlobal ? placeId : !merchantId ? placeId : '653f5d9006520fccd4ab4604',
                isView: true
            });
            if (error) throw error;
            if (data) {
                setRows(data);
                setLoading(false)
            }
        } catch (error) {
        }
    }

    const loadMerchantSportCourtTypeData = async () => {
        try {
            let { data, error } = await getSportCourtTypes(
                merchantId, placeId
            );
            if (error) throw error;
            if (data) {
                setMerchantSportCourtType(data);
                setLoading(false)
            }
        } catch (error) {
            console.log(error);
            setLoading(false)
        }
    }

    useEffect(() => {
        loadData();
    }, [dialog.open == false]);

    useEffect(() => {
        loadData()
        if (isGlobal || placeId == "69b3a2e8c994e1353f8b2074") {
            loadMerchantSportCourtTypeData();
        }
    }, [isGlobal])

    const categoryKeyOf = (v) => `${v._id}`;
    const categoryLabelOf = (v) => `${v.sportTypeId?.name} ${v.courtTypeId?.name}`;
    const getRowId = (row) => row._id || row.id || row.name; // pick your best unique id

    const toggleRow = (rowId, row) => {
        setSelectedRows((prev) => {
            const next = new Set(prev);
            if (next.has(rowId)) next.delete(rowId);
            else next.add(rowId);
            return next;
        });
        // check row information
        console.log('here row', row)
        let form = {
            _id: row._id,
            merchant: merchantId,
            place: placeId
        }
        update(form)
    };

    const update = async (form) => {
        try {
            if (form.place && !form.merchant) {
                let { data, error } = await updatePackageSportCourtTypePlaceGlobal(form);
                if (error) throw error;
                if (data) {
                    toast.success('Value pack category updated successfully');
                    setRows([]);
                    setSelectedRows(new Set())
                    setSelectedCategoriesByRow({})
                    loadData();
                }
                return;
            }
            let { data, error } = await updatePackageSportCourtTypeGlobal(form);
            if (error) throw error;
            if (data) {
                toast.success('Value pack category updated successfully');
                setRows([]);
                setSelectedRows(new Set())
                setSelectedCategoriesByRow({})
                loadData();
            }
        } catch (error) {
            console.log(error);
        }
    }

    const toggleCategory = (rowId, categoryKey, row) => {
        setSelectedCategoriesByRow((prev) => {
            const prevSet = prev[rowId] || new Set();
            const nextSet = new Set(prevSet);

            if (nextSet.has(categoryKey)) nextSet.delete(categoryKey);
            else nextSet.add(categoryKey);

            return { ...prev, [rowId]: nextSet };
        });
        // remove
        const idx = row.sportCourtTypeId.findIndex(
            (v) => v._id.toString() === categoryKey.toString()
        );
        if (idx !== -1) {
            row.sportCourtTypeId.splice(idx, 1); // remove it
        } else {
            row.sportCourtTypeId.push({ _id: categoryKey }); // or push the full object
        }
        let form = {
            _id: row._id,
            sportCourtTypeId: row.sportCourtTypeId
        }
        updateSportCat(form)
    };

    const updateSportCat = async (form) => {
        try {
            let { data, error } = await updatePackageSportCourtType(form);
            if (error) throw error;
            if (data) {
                toast.success('Value pack category updated successfully');
                loadData();
            }
        } catch (error) {
            console.log(error);
        }
    }

    // useEffect(() => {
    //     if (!rows || !merchantSportCourtType) { return }
    //     if (rows == [] || merchantSportCourtType == []) { return }
    //     const next = new Set();
    //     const cat = {};
    //     const nextCat = new Set();
    //     for (let i = 0; i < rows.length; i++) {
    //         console.log('here rows', rows[i])
    //         if (rows[i].globalMerchants && rows[i].globalMerchants.some(v => v.toString() === merchantId.toString())) {
    //             next.add(rows[i]._id)
    //             for (let j = 0; j < merchantSportCourtType.length; j++) {
    //                 if (rows[i].sportCourtTypeId && rows[i].sportCourtTypeId.some(v => v._id.toString() === merchantSportCourtType[j]._id.toString())) {
    //                     console.log('added', merchantSportCourtType[j]._id, rows[i].sportCourtTypeId)
    //                     nextCat.add(merchantSportCourtType[j]._id)
    //                 }
    //             }
    //             cat[rows[i]._id] = nextCat
    //         }
    //     }
    //     console.log("here cat", cat)
    //     setSelectedRows(next)
    //     setSelectedCategoriesByRow(cat)
    // }, [rows, merchantSportCourtType])
    useEffect(() => {
        if (!rows?.length || !merchantSportCourtType?.length) return;

        const next = new Set();
        const cat = {};

        for (let i = 0; i < rows.length; i++) {
            const merchantMatched =
                rows[i].globalMerchants &&
                merchantId &&
                rows[i].globalMerchants.some(v => v.toString() === merchantId.toString());

            const placeMatched =
                rows[i].globalPlaces &&
                placeId &&
                rows[i].globalPlaces.some(v => v.toString() === placeId.toString());

            if (merchantMatched || placeMatched) {
                next.add(rows[i]._id);

                const nextCat = new Set();

                for (let j = 0; j < merchantSportCourtType.length; j++) {
                    if (
                        rows[i].sportCourtTypeId &&
                        rows[i].sportCourtTypeId.some(
                            v => v._id.toString() === merchantSportCourtType[j]._id.toString()
                        )
                    ) {
                        nextCat.add(merchantSportCourtType[j]._id);
                    }
                }

                cat[rows[i]._id] = nextCat;
            }
        }

        setSelectedRows(next);
        setSelectedCategoriesByRow(cat);
    }, [rows, merchantSportCourtType, merchantId, placeId]);

    const valueCustomator = (row) => {
        const rowId = getRowId(row);
        if ((merchantId && isGlobal) || placeId == "69b3a2e8c994e1353f8b2074") {
            return ({
                name: <Stack direction="row" spacing={1} alignItems="center">
                    <Checkbox
                        size="small"
                        checked={selectedRows.has(rowId)}
                        onChange={() => toggleRow(rowId, row)}
                    />
                    <TCLabel>{row.name}</TCLabel>
                </Stack>,
                courtType: <TCLabel>{row.isAllCourt ? 'All Court' : `${row.sportCourtTypeId.map(v => { return `${v.sportTypeId.name} ${v.courtTypeId.name}` }).join(', ')}`}</TCLabel>,
                sportCategory: <Stack spacing={0.5} direction={"row"}>
                    {merchantSportCourtType.map((v) => {
                        const key = categoryKeyOf(v);
                        const checked = !!selectedCategoriesByRow[rowId]?.has(key);
                        return (
                            <Stack key={key} direction="row" spacing={1} alignItems="center">
                                <Checkbox
                                    disabled={!selectedRows.has(rowId)}
                                    size="small"
                                    checked={checked}
                                    onChange={() => toggleCategory(rowId, key, row)}
                                />
                                <TCLabel>{categoryLabelOf(v)}</TCLabel>
                            </Stack>
                        );
                    })}
                </Stack>,
            })
        } else {
            return ({
                name: isGlobal ? <TCLabel>{row.name}</TCLabel> : <span className='span-link' onClick={() => {
                    setDialog({ open: true, data: row });
                }}>{row.name}</span>,
                courtType: <TCLabel>{row.isAllCourt ? 'All Court' : `${row.sportCourtTypeId.map(v => { return `${v.sportTypeId.name} ${v.courtTypeId.name}` }).join(', ')}`}</TCLabel>,
            })
        }
    }

    const updateGlobalStatus = async (global) => {
        let { data, error } = await updateMerchantSettings(merchantId, {
            valuePackGlobal: global
        })
        if (data) {
            toast.success('Settings Updated')
        }
    }

    return (
        <>
            <Box display={"flex"} alignItems={"center"} justifyContent={"space-between"} sx={{ mb: 2 }} >
                <Button disabled={isGlobal} variant="contained" color="primary" onClick={() => {
                    setDialog({
                        open: true,
                        data: null,
                    });
                }}>Add Value Pack Category</Button>
                <FormControlLabel
                    label="Global"
                    disabled={!merchantId}
                    control={<Checkbox
                        id="value-pack-merchant-checkbox"
                        checked={isGlobal}
                        onChange={() => {
                            let global = !isGlobal
                            setIsGlobal(global)
                            updateGlobalStatus(global)
                        }}
                    />}

                />
            </Box>
            <TableComponent
                columns={(merchantId || placeId === "69b3a2e8c994e1353f8b2074") && isGlobal ? [
                    { label: "Value Pack Name" },
                    { label: "Sport Court Type" },
                    { label: "Merchant Sport Category" },
                ] : [
                    { label: "Value Pack Name" },
                    { label: "Sport Court Type" },
                ]}
                rows={rows}
                valueCustomator={valueCustomator}
                loading={isLoading}
            />
            <AddValuePackCategoryDialog isGlobal={isGlobal} merchantId={merchantId} placeId={placeId} setDialog={dialog} data={dialog.data} handleClose={() => {
                setDialog({
                    open: false,
                    data: null,
                });
                loadData();
            }} />
        </>
    );
}
